import { computePosition, flip, shift, offset, arrow } from '@floating-ui/vue';

export const tooltipDirective = {
  mounted(el, binding) {
    if (!binding.value) return;

    // 1. Créer le Tooltip
    const tooltip = document.createElement('div');
    tooltip.className = 'v-tooltip-floating';
    
    // Créer un span pour le texte (pour ne pas écraser la flèche plus tard)
    const textSpan = document.createElement('span');
    textSpan.textContent = binding.value;
    tooltip.appendChild(textSpan);

    // 2. Créer la Flèche
    const arrowEl = document.createElement('div');
    arrowEl.className = 'v-tooltip-arrow';
    tooltip.appendChild(arrowEl);

    document.body.appendChild(tooltip);
    el._tooltip = tooltip;
    el._textSpan = textSpan; // Référence pour la mise à jour

    const updatePosition = () => {
      computePosition(el, tooltip, {
        placement: 'top',
        middleware: [
          offset(10), 
          flip(), 
          shift({ padding: 5 }), 
          arrow({ element: arrowEl })
        ],
      }).then(({ x, y, placement, middlewareData }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });

        if (middlewareData.arrow) {
          const { x: arrowX, y: arrowY } = middlewareData.arrow;
          const staticSide = {
            top: 'bottom',
            right: 'left',
            bottom: 'top',
            left: 'right',
          }[placement.split('-')[0]];

          Object.assign(arrowEl.style, {
            left: arrowX != null ? `${arrowX}px` : '',
            top: arrowY != null ? `${arrowY}px` : '',
            [staticSide]: '-4px', // Sort de 4px pour créer la pointe
          });
        }
      });
    };

    const delayOpen = binding.value?.delay?.open ?? 0;
    const delayClose = binding.value?.delay?.close ?? 0;

    let openTimer = null;
    let closeTimer = null;

    el._showTooltip = () => {
        clearTimeout(closeTimer);
        
        openTimer = setTimeout(() => {
            tooltip.style.display = 'block';
            updatePosition();
        }, delayOpen);
    };
    el._hideTooltip = () => {
        clearTimeout(openTimer);
        
        closeTimer = setTimeout(() => {
            tooltip.style.display = 'none';
        }, delayClose);
    };

    el.addEventListener('mouseenter', el._showTooltip);
    el.addEventListener('mouseleave', el._hideTooltip);
  },

  updated(el, binding) {
    if (el._textSpan) {
      el._textSpan.textContent = binding.value;
    }
  },

  unmounted(el) {
    if (el._tooltip) {
      el.removeEventListener('mouseenter', el._showTooltip);
      el.removeEventListener('mouseleave', el._hideTooltip);
      el._tooltip.remove();
    }
  }
};